export const botonicUpdateUserExtraData = (extraData: any) => {
  // @ts-expect-error Property 'Botonic' does not exist on type 'Window & typeof globalThis'.
  window.Botonic && window.Botonic.updateUser({ extra_data: extraData })
}
